function isInViewport(element) {
    const rect = element.getBoundingClientRect();

    return rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

window.addEventListener('scroll', function(){

    if (isInViewport(document.querySelector('.main-pdp-form'))){
      document.querySelector('.product-form__buttons[data-sticky-atc]').classList.remove('is-sticky')
      document.body.classList.remove('chat-visible');
    } else {
      document.querySelector('.product-form__buttons[data-sticky-atc]').classList.add('is-sticky')
      document.body.classList.add('chat-visible');
    }
})


window.addEventListener("DOMContentLoaded", function(){

    if( typeof(document.querySelector(".promo_col_5")) != 'undefined' ){
        document.querySelector(".promo_col_5").style.display = 'none';
        document.querySelector(".promo_col_5").style.display = 'block';
    }

});

function changeVariant(element){
    const selectedOption = element.options[element.selectedIndex];
    const options = [
      selectedOption.getAttribute('data-option-1'),
      selectedOption.getAttribute('data-option-2'),
      selectedOption.getAttribute('data-option-3')
    ];
    options.forEach(option => {
      if (option !== null) { 
        const input = document.querySelector(`.swatch_wrapper [data-option-title="${option}"]`);
        if (input && !input.checked) {
          input.checked = true;
          const changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          input.dispatchEvent(changeEvent);
        }
      }
    });
  }

